module.exports = __webpack_public_path__ + "img/banner-accessibility.829c7e54.webp";